<template>
    <div class="hour-range-filter">
        <div v-if="!hideLabel" class="caption grey--text mb-1">{{ label }}</div>
        <v-autocomplete
            :value="value"
            @input="onInput"
            :items="items"
            :loading="loading"
            :disabled="disabled || (!loading && !hasOptions)"
            :placeholder="effectivePlaceholder"
            :no-data-text="emptyText"
            item-text="label"
            item-value="id"
            outlined
            :dense="dense"
            hide-details
            clearable
        >
            <template v-slot:item="{ item }">
                <template v-if="item.header">
                    <v-list-item-content class="py-0">
                        <v-list-item-subtitle class="hour-range-filter__shift">
                            {{ item.header }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </template>
                <template v-else>
                    <v-list-item-content class="hour-range-filter__hour">
                        <v-list-item-title>{{ item.label }}</v-list-item-title>
                    </v-list-item-content>
                </template>
            </template>
        </v-autocomplete>
        <div
            v-if="!loading && !hasOptions && !disabled"
            class="caption error--text mt-1"
        >
            <v-icon x-small color="error">mdi-alert-circle-outline</v-icon>
            Sem horários cadastrados na grade institucional.
        </div>
    </div>
</template>

<script>
let cachedGroupsPromise = null

function fetchGroups(http) {
    if (cachedGroupsPromise) return cachedGroupsPromise
    cachedGroupsPromise = http.get('hours/vacancy-filter')
        .then(response => {
            const body = response.body || {}
            const payload = body.data ?? body
            const groups = Array.isArray(payload?.groups) ? payload.groups : []
            return groups
        })
        .catch(() => {
            cachedGroupsPromise = null
            return []
        })
    return cachedGroupsPromise
}

export default {
    name: 'HourRangeFilter',
    props: {
        value: { type: [Number, String], default: null },
        label: { type: String, default: 'Horário' },
        placeholder: { type: String, default: null },
        dense: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
        hideLabel: { type: Boolean, default: false },
    },
    data() {
        return {
            loading: false,
            groups: [],
        }
    },
    computed: {
        hasOptions() {
            return this.groups.some(g => Array.isArray(g.hours) && g.hours.length > 0)
        },
        items() {
            if (!this.hasOptions) return []
            const out = []
            this.groups.forEach((group, idx) => {
                const hours = Array.isArray(group.hours) ? group.hours : []
                if (!hours.length) return
                if (idx > 0) out.push({ divider: true })
                out.push({ header: group.shift_name || '—' })
                hours.forEach(h => {
                    out.push({
                        id: Number(h.id),
                        label: h.label || `${h.start} — ${h.end}`,
                        start: h.start,
                        end: h.end,
                        shift_id: group.shift_id,
                    })
                })
            })
            return out
        },
        effectivePlaceholder() {
            if (this.loading) return 'Carregando horários...'
            if (!this.hasOptions) return 'Sem horários cadastrados'
            return this.placeholder || 'Todos os horários'
        },
        emptyText() {
            return this.loading
                ? 'Carregando...'
                : 'Sem horários cadastrados na grade institucional.'
        },
    },
    mounted() {
        this.load()
    },
    methods: {
        async load() {
            this.loading = true
            try {
                this.groups = await fetchGroups(this.$http)
            } finally {
                this.loading = false
            }
        },
        onInput(value) {
            const normalized = value === null || value === undefined || value === ''
                ? null
                : Number(value)
            this.$emit('input', normalized)
            this.$emit('change', normalized)
        },
    },
}
</script>

<style scoped>
.hour-range-filter__shift {
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6b7280;
    font-size: 11px;
    font-weight: 600;
}
.hour-range-filter__hour {
    padding-left: 8px;
}
</style>
